export default "__VITE_ASSET__DB1az8El__"